// パネル幅などのレイアウト状態 (localStorage に保存)。参照プロジェクト useLayout.ts 流用。
import { ref, watch } from 'vue'

const STORAGE_KEY = 'bpe.layout.v1'

const LAYOUT_DEFAULTS = { rightWidth: 300 }
const LIMITS = { rightWidth: { min: 220, max: 600 } }

type LayoutKey = keyof typeof LAYOUT_DEFAULTS

function clampValue(key: LayoutKey, v: number): number {
  const l = LIMITS[key]
  return Math.min(l.max, Math.max(l.min, Math.round(v)))
}

function loadStored(): typeof LAYOUT_DEFAULTS {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<Record<LayoutKey, number>>
      const out = { ...LAYOUT_DEFAULTS }
      for (const k of Object.keys(LAYOUT_DEFAULTS) as LayoutKey[]) {
        const v = parsed[k]
        if (typeof v === 'number' && Number.isFinite(v)) out[k] = clampValue(k, v)
      }
      return out
    }
  } catch {
    /* ignore */
  }
  return { ...LAYOUT_DEFAULTS }
}

const stored = loadStored()
const rightWidth = ref(stored.rightWidth)

watch([rightWidth], () => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ rightWidth: rightWidth.value }))
  } catch {
    /* ignore */
  }
})

export function useLayout() {
  function setRightWidth(v: number) {
    rightWidth.value = clampValue('rightWidth', v)
  }
  function reset(key: LayoutKey) {
    if (key === 'rightWidth') rightWidth.value = LAYOUT_DEFAULTS.rightWidth
  }
  return { rightWidth, setRightWidth, reset }
}
